// extracted by mini-css-extract-plugin
module.exports = {"data":"styles_data__1HOaj","title":"styles_title__1jALw","description":"styles_description__1TDWb","buttonsWrap":"styles_buttonsWrap__2Z7e4"};